let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("c19sg")).then(() => parcelRequire('bNhr6'));